/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import ScPagination from '@app/components/Shares/Pagination';
import {
    BUTTON_ACTION_TYPE,
    ButtonTableAction,
} from '@app/components/UI/Button';
import useInvoiceFormPageStore from '../hooks/usePageStore';

const PAGE_SIZE = 10;

interface InvoiceFormListProps {
    list: any[];
    total: number;
    isLoading: boolean;
}

const InvoiceFormList = ({ list, total, isLoading }: InvoiceFormListProps) => {
    const { filterParams, setFilterParams, openPopup } =
        useInvoiceFormPageStore();

    const onChangePage = (page: number) => {
        setFilterParams({ currentPage: page });
    };

    const columns: ColumnsType<any> = [
        {
            title: 'STT',
            align: 'center',
            width: 60,
            render: (_: any, __: any, index: number) =>
                (filterParams.currentPage - 1) * PAGE_SIZE + index + 1,
        },
        {
            title: 'Tên mẫu hóa đơn',
            dataIndex: 'if_reporttitle',
            key: 'if_reporttitle',
            width: 200,
        },
        {
            title: 'Tên công ty thực phẩm',
            dataIndex: 'if_companyname',
            key: 'if_companyname',
        },
        {
            title: 'Hành động',
            align: 'center',
            width: 80,
            render: (_: any, record: any) => (
                <ButtonTableAction
                    tootTipTitle="Chỉnh sửa"
                    buttonType={BUTTON_ACTION_TYPE.EDIT}
                    onClick={() => openPopup(record)}
                />
            ),
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                dataSource={list}
                loading={isLoading}
                rowKey={(record) => record?.id}
                pagination={false}
                bordered
                size="middle"
            />

            <ScPagination
                currentPage={filterParams.currentPage}
                pageSize={PAGE_SIZE}
                total={total}
                currentCount={list.length}
                onChange={onChangePage}
                showSizeChanger={false}
            />
        </>
    );
};

export default InvoiceFormList;
